import { z } from "zod";

// Function to create the schema dynamically
export const createTenderQuotationSchema = (t: (key: string) => string) =>
  z
    .object({
      id: z.string().nullable(),
      OpportunityNr: z.number().nullable(),
      tenderId: z.string().nonempty(t("tenders.idRequired")),
      companyId: z
        .string()
        .nonempty(t("quotations.validation.companyidRequired")),
      products: z
        .array(
          z.object({
            productId: z.string(),
            unitName: z.string(),
            SKUCode: z.string(),
            quantity: z.preprocess(
              (val) => (val === "" ? 0 : Number(val)),
              z
                .number({
                  required_error: t("quatation.validation.quantityRequired"),
                  invalid_type_error: t(
                    "quatation.validation.quantityMustBeNumber"
                  ),
                })
                .positive(t("quatation.validation.quantityMustBePositive"))
            ),
            unitPrice: z.preprocess(
              (val) => (val === "" ? 0 : Number(val)),
              z
                .number({
                  required_error: t("quotations.validation.UnitPriceRequired"),
                  invalid_type_error: t(
                    "quotations.validation.UnitPriceMustBeNumber"
                  ),
                })
                .positive(t("quotations.validation.UnitPriceMustBePositive"))
            ),
            vat: z.number(),
            notice: z.string(),
            attachment: z.instanceof(File).nullable().optional(),
            image: z.string().nullable().optional(),
          })
        )
        .optional(),
      deliverDays: z
        .number()
        .min(1, t("quotations.validation.DeliverDaysRequired")),
      DeadLineDate: z
        .string()
        .min(1, t("quotations.validation.DeadlineDateRequired")),
      status: z.enum(["Pending", "Accepted"]).default("Pending"),
      paymentMethod: z.enum(["1", "2"]).default("1"),
      DeliveryMethod: z.string(),
      customDeliveryMethod: z.string().optional(),
      contactMethod: z.enum(["1", "2"]).default("1"),
    })
    .refine(
      (data) => {
        if (data.DeliveryMethod === "Other" && !data.customDeliveryMethod) {
          return false;
        }
        return true;
      },
      {
        path: ["customDeliveryMethod"],
        message: t("quotations.validation.CustomDeliveryMethodRequired"),
      }
    );

// Define the type using the function's return value
export type TenderQuotation = z.infer<
  ReturnType<typeof createTenderQuotationSchema>
>;
